module.exports = __webpack_public_path__ + "media/images/california-unemployment-rate-bb9dc6130f4962316aa6679fd714a4a3.png";